let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
import PrintService from "../../service/PrintService.js";

let main = function () {
    var ThirdPartyBillView = Backbone.View.extend({
        events: {
            "click .print-receipt":"_print",
            "click .close-modal":"_close"
        },
        initialize: function (params) {
            this.bill = params.bill;
            this.model = params.model;
        },
        show: function(){
            this.$el.modal("show");
        },
        hide: function() {
            this.$el.modal("hide");
        },
        _print:function(){
            PrintService.printCashierReceipt(this.bill);
            this.model.set({"close":true});
        },
        _close:function(){
            this.model.set({"close":true});
        },
        resetModel:function(){
            var self = this;
            self.model.set({
                deviceQuantity: 2,
                duration: 1,
                amount: self.calculateLicensePrice(),
                price: window.TOOIE_INIT_PARAMS.charges.price,
                channel: "alipay_qr",
                chargesId: self.$el.find(".purchase-license").data('id')
            });
        }
    });
    return ThirdPartyBillView;
};

let exportedValue = main();
export default exportedValue;



// WEBPACK FOOTER //
// ./src/view/comp/ThirdPartyBillView.js